import pako from 'pako';
import { SnapshotFormat } from './definitions';
import type { SnapshotData } from './definitions';

export class RawObjectSnapshotData<PayloadType> implements SnapshotData<PayloadType, PayloadType> {
    public static async fromSerializedData<PayloadType>(data: PayloadType) {
        return new this(data);
    }

    public constructor(private payload: PayloadType) {}

    public async serialize() {
        return {
            data: this.payload,
            // 为性能考虑，这里使用估计值
            size: JSON.stringify(this.payload).length * 2,
            format: SnapshotFormat.RawObject,
        };
    }

    public async getPayload() {
        return this.payload;
    }
}

export class JSONSnapshotData<PayloadType> implements SnapshotData<PayloadType, string> {
    public static async fromSerializedData<PayloadType>(data: string) {
        return new this(JSON.parse(data) as PayloadType);
    }

    public constructor(private payload: PayloadType) {}

    public async serialize() {
        const data = JSON.stringify(this.payload);
        return {
            data,
            // 为性能考虑，这里使用估计值
            size: data.length * 2,
            format: SnapshotFormat.JSON,
        };
    }

    public async getPayload() {
        return this.payload;
    }
}

export class ZlibSnapshotData<PayloadType> implements SnapshotData<PayloadType, Uint8Array> {
    public static async fromSerializedData<PayloadType>(data: Uint8Array) {
        const payload = JSON.parse(pako.inflate(data, { to: 'string' })) as PayloadType;
        return new this(payload);
    }

    public constructor(private payload: PayloadType) {}

    public async serialize() {
        const data = pako.deflate(JSON.stringify(this.payload));
        return {
            data,
            size: data.length,
            format: SnapshotFormat.JSON,
        };
    }

    public async getPayload() {
        return this.payload;
    }
}
